import { render, staticRenderFns } from "./WorkMessageReport.vue?vue&type=template&id=d2ae2e0a&scoped=true"
import script from "./WorkMessageReport.vue?vue&type=script&lang=js"
export * from "./WorkMessageReport.vue?vue&type=script&lang=js"
import style0 from "./WorkMessageReport.vue?vue&type=style&index=0&id=d2ae2e0a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2ae2e0a",
  null
  
)

export default component.exports